import { useCallback } from "react";

import * as Shared from "../../../../_shared";

export const useMaxStockNum = () => {
	const { viewModel, onSetViewModel } = Shared.Model.Context.useMarketingVoucherEditContext();
	const { maxStockNum } = viewModel;

	const onSetMaxStockNum = useCallback(
		(input: number | undefined) => {
			onSetViewModel([
				{
					key: "maxStockNum",
					value: {
						isEdited: true,
						value: input!,
					},
				},
			]);
		},
		[onSetViewModel],
	);

	return {
		maxStockNum,
		onSetMaxStockNum,
	};
};
